type ItemComSalao = {
  numeroPedido?: number | null;
  pedidoFoodfly?: {
    mesaId?: string | null;
    comandaId?: string | null;
    identificador?: string | null;
  } | null;
};

/** Filtra item da fila de produção por nº de mesa, comanda ou pedido. */
export function matchesMesaComandaSearch(
  item: ItemComSalao,
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;

  const digits = q.replace(/\D/g, "");
  const mesa = String(item.pedidoFoodfly?.mesaId ?? "").toLowerCase();
  const comanda = String(item.pedidoFoodfly?.comandaId ?? "").toLowerCase();
  const identificador = String(
    item.pedidoFoodfly?.identificador ?? "",
  ).toLowerCase();
  const numero = String(item.numeroPedido ?? "");

  if (digits) {
    const mesaD = mesa.replace(/\D/g, "");
    const comandaD = comanda.replace(/\D/g, "");
    if (
      mesaD.includes(digits) ||
      comandaD.includes(digits) ||
      numero.includes(digits)
    ) {
      return true;
    }
  }

  return (
    mesa.includes(q) ||
    comanda.includes(q) ||
    identificador.includes(q) ||
    numero.includes(q)
  );
}
